import { useQuery } from '@tanstack/react-query';

import api from 'apis/restaurant-api/api';

import { CountryConfig } from '../../modules/country/types';

const getCountryConfigs = (country: Country) =>
  api.get<CountryConfig>(`/v1/country_configs/${country}`).then(response => response.data);

const useCountryConfig = (
  country: Country | null,
  options?: {
    enabled?: boolean;
    refetchOnMount?: boolean;
    refetchOnWindowFocus?: boolean;
    retry?: boolean;
  },
) => {
  const {
    data: countryConfig,
    error,
    isFetching,
  } = useQuery(['/v1/country_configs', country], () => (country ? getCountryConfigs(country) : null), {
    enabled: !!country,
    ...options,
  });
  return { countryConfig, error, isFetching };
};

export default useCountryConfig;
